import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ICurrentWorkspaceStore } from '../../workspaces/currentWorkspace/CurrentWorkspace.store';
import { CloudCostsTabs } from '../components/CloudCostsTabs';

export const CloudCostsTabsContainer = observer((): ReactElement => {
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);

  return <CloudCostsTabs workspaceId={currentWorkspaceStore.currentWorkspace.id} />;
});
